import BaseType from "../BaseType";
import Guid from "../Guid";

export default class OutreachRequestNote extends BaseType {
  OutreachRequestId: string = Guid.Empty;
  Text: string = "";
  DisplayDate: string = "";
}
